(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-card-nav__arrow');
    if (!button) return;

    const nav = button.closest('.product-card-nav');
    if (!nav) return;

    event.preventDefault();

    const direction = button.getAttribute('data-nav');
    const current = nav.getAttribute('data-state') || 'current';
    let target = current;

    if (direction === 'next') {
      target = current === 'current' ? 'next' : 'current';
    } else if (direction === 'prev') {
      target = current === 'current' ? 'prev' : 'current';
    }

    nav.querySelectorAll('.product-card-nav__panel').forEach((panel) => {
      panel.hidden = panel.getAttribute('data-role') !== target;
    });

    nav.setAttribute('data-state', target);
  });

  } catch(e) { console.error(e); }
})();
})();
